export default __webpack_public_path__ + "static/media/65ba488626025cff82f091336fbf94bb.45df2d82.gif";